import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { _HttpClient } from '@delon/theme';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'app-mobile-app-qr-code',
  templateUrl: './mobile-app-qr-code.component.html',
  styleUrls: ['./mobile-app-qr-code.component.less'],
  standalone: true,
  imports: [
    NzInputModule,
    NzButtonModule,
    NzModalModule,
    CommonModule,
    FormsModule,
    NzToolTipModule,
    NzIconModule
  ]
})
export class MobileAppQrCodeComponent {
  isVisible = false;
  imgSrc: string = '';
  downloadLink: string = '';
  isCopied: boolean = false;

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly http: _HttpClient
  ) {}

  show() {
    this.isVisible = true;
  }

  close() {
    this.isVisible = false;
  }

  onQrClick() {
    window.open(
      'https://play.google.com/store/apps/details?id=com.qne.app',
      '_blank'
    );
  }
}
